{
  "$id": "wealthlane://forms/job-scheduler/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "id": "jobSchedulerAwardTypeClearsGrants",
      "watch": "taskInstruction.taskExecutionDto.awardTypeId",
      "clear": ["taskInstruction.taskExecutionDto.grantIds"]
    }
  ],
  "observers": [
    {
      "id": "jobSchedulerRecurrenceStartDateChanged",
      "watch": "recurrenceStartDate",
      "condition": {
        "allOf": [
          { "field": "recurrenceTypeId", "notEmpty": true },
          { "field": "recurrenceStartDate", "notEmpty": true }
        ]
      },
      "debounceMs": 250,
      "lookup": {
        "actionId": "HANDLE_JOB_SCHEDULER_RECURRENCE_CHANGE",
        "params": {
          "recurrenceTypeId": "recurrenceTypeId",
          "recurrenceStartDate": "recurrenceStartDate",
          "recurrenceStartTime": "recurrenceStartTime",
          "customRecurrenceInstructionsJson": "recurrenceInstructionsJson.customRecurrenceInstructionsJson",
          "restrictOpen": "true"
        }
      },
      "mapTo": {
        "cronExpression": "recurrenceInstructionsJson.cronExpression",
        "customRecurrenceInstructionsJson": "recurrenceInstructionsJson.customRecurrenceInstructionsJson",
        "recurrenceDisplayText": "recurrenceDisplayText"
      }
    },
    {
      "id": "jobSchedulerRecurrenceStartTimeChanged",
      "watch": "recurrenceStartTime",
      "condition": {
        "allOf": [
          { "field": "recurrenceTypeId", "notEmpty": true },
          { "field": "recurrenceStartTime", "notEmpty": true }
        ]
      },
      "debounceMs": 250,
      "lookup": {
        "actionId": "HANDLE_JOB_SCHEDULER_RECURRENCE_CHANGE",
        "params": {
          "recurrenceTypeId": "recurrenceTypeId",
          "recurrenceStartDate": "recurrenceStartDate",
          "recurrenceStartTime": "recurrenceStartTime",
          "customRecurrenceInstructionsJson": "recurrenceInstructionsJson.customRecurrenceInstructionsJson",
          "restrictOpen": "true"
        }
      },
      "mapTo": {
        "cronExpression": "recurrenceInstructionsJson.cronExpression",
        "customRecurrenceInstructionsJson": "recurrenceInstructionsJson.customRecurrenceInstructionsJson",
        "recurrenceDisplayText": "recurrenceDisplayText"
      }
    },
    {
      "id": "jobSchedulerRecurrenceStartWeekdayHint",
      "watch": "recurrenceStartDate",
      "condition": { "field": "recurrenceStartDate", "notEmpty": true },
      "lookup": {
        "actionId": "FORMAT_JOB_SCHEDULER_START_WEEKDAY",
        "params": { "recurrenceStartDate": "recurrenceStartDate" }
      },
      "mapTo": { "weekdayHint": "recurrenceStartWeekdayHint" }
    },
    {
      "id": "jobSchedulerRecurrenceTypeChanged",
      "watch": "recurrenceTypeId",
      "condition": { "field": "recurrenceTypeId", "notEmpty": true },
      "lookup": {
        "actionId": "HANDLE_JOB_SCHEDULER_RECURRENCE_CHANGE",
        "params": {
          "recurrenceTypeId": "recurrenceTypeId",
          "recurrenceStartDate": "recurrenceStartDate",
          "recurrenceStartTime": "recurrenceStartTime",
          "customRecurrenceInstructionsJson": "recurrenceInstructionsJson.customRecurrenceInstructionsJson",
          "restrictOpen": "false"
        }
      },
      "mapTo": {
        "cronExpression": "recurrenceInstructionsJson.cronExpression",
        "customRecurrenceInstructionsJson": "recurrenceInstructionsJson.customRecurrenceInstructionsJson",
        "recurrenceDisplayText": "recurrenceDisplayText"
      }
    },
    {
      "id": "jobSchedulerTaskTypeChanged",
      "watch": "taskTypeId",
      "condition": { "field": "taskTypeId", "notEmpty": true },
      "lookup": {
        "actionId": "HANDLE_JOB_SCHEDULER_TASK_TYPE_CHANGE",
        "params": { "taskTypeId": "taskTypeId" }
      },
      "mapTo": {
        "taskDetailsName": "taskDetailsName",
        "taskInstructionTaskDetailsName": "taskInstruction.taskDetailsName",
        "clearedTaskDetailId": "taskInstruction.taskDetailId",
        "taskExecutionDto": "taskInstruction.taskExecutionDto"
      },
      "cascade": true
    },
    {
      "id": "jobSchedulerCustomReportChanged",
      "watch": "taskInstruction.taskDetailId",
      "condition": { "field": "taskInstruction.taskDetailId", "notEmpty": true },
      "lookup": {
        "actionId": "HANDLE_JOB_SCHEDULER_TASK_DETAIL_CHANGE",
        "params": {
          "taskDetailId": "taskInstruction.taskDetailId",
          "scheduleId": "id"
        }
      },
      "mapTo": {
        "taskExecutionDto": "taskInstruction.taskExecutionDto",
        "taskInstructionTaskDetailsName": "taskInstruction.taskDetailsName"
      },
      "cascade": true
    }
  ],
  "rules": [
    {
      "id": "jobSchedulerReleaseExerciseTimeIntervalRequired",
      "target": "taskInstruction.taskExecutionDto.timeInterval",
      "rule": "required",
      "condition": {
        "field": "taskDetailsName",
        "in": ["Release Automation", "Exercise Automation"]
      },
      "message": "Required field"
    },
    {
      "id": "jobSchedulerReleaseExerciseConfigurationMinItems",
      "target": "taskInstruction.taskExecutionDto.configuration",
      "rule": "arrayMinItems",
      "minValue": 1,
      "condition": {
        "field": "taskDetailsName",
        "in": ["Release Automation", "Exercise Automation"]
      },
      "message": "Required field"
    },
    {
      "id": "jobSchedulerTaskDetailRequired",
      "target": "taskInstruction.taskDetailId",
      "rule": "required",
      "condition": {
        "not": {
          "field": "taskDetailsName",
          "in": ["Release Automation", "Exercise Automation"]
        }
      },
      "message": "Required field"
    },
    {
      "id": "jobSchedulerReleaseAwardTypeRequired",
      "target": "taskInstruction.taskExecutionDto.awardTypeId",
      "rule": "required",
      "condition": { "field": "taskDetailsName", "equals": "Release Automation" },
      "message": "Required field"
    }
  ]
}
